import type { ComponentType } from 'react';

/**
 * 개발용 실험 페이지 레지스트리.
 *
 * 새 실험을 추가하려면: (1) `src/app/dev/`에 페이지 컴포넌트를 default export로 만들고
 * (2) 아래 배열에 항목 하나를 추가한다. → `/dev` 목록과 `/dev/{path}` 라우트에 자동 반영된다.
 *
 * `load`는 반드시 정적 문자열 import를 담은 팩토리(`() => import('./Foo')`)여야 번들 분석/코드 스플릿이 동작한다.
 */
export interface DevExperiment {
  /** URL 세그먼트 (/dev/{path}) */
  path: string;
  title: string;
  description: string;
  load: () => Promise<{ default: ComponentType<unknown> }>;
}

export const DEV_EXPERIMENTS: DevExperiment[] = [
  {
    path: 'react-compiler',
    title: 'React Compiler 적용 확인',
    description: 'element 캐싱·useCallback 자동 안정화를 컴파일 vs 미적용으로 비교',
    load: () => import('./ReactCompilerCheckPage'),
  },
  {
    path: 'stim-diary-gallery',
    title: 'STIM 치료일기 갤러리',
    description: 'STIM 치료일기 화면들을 상태별로 모아 보는 리뷰 전용 갤러리',
    load: () => import('./MStimDiaryGalleryPage'),
  },
  {
    path: 'empty-state-gallery',
    title: '빈 상태 갤러리',
    description: '상세 화면들의 빈 상태를 모아 보는 리뷰 전용 갤러리 (EmptyState variant="page")',
    load: () => import('./EmptyStateGalleryPage'),
  },
  {
    path: 'dashboard-gallery',
    title: '대시보드 상태 갤러리',
    description: '환자 대시보드 카드와 서비스 이용 현황 행을 상태별로 모아 보는 리뷰 전용 갤러리',
    load: () => import('./DashboardGalleryPage'),
  },
];
